import axios from "axios";

const baseURL = process.env.REACT_APP_PURCHASE_ORDER;

const PurchaseOrderClient = axios.create({
  baseURL,
});

PurchaseOrderClient.interceptors.response.use(
  (res) => res.data,
  (error) => Promise.reject(error)
);

export default PurchaseOrderClient;
